export const ASSETS_BASE_URL = "https://assets.wonmov.com/";